import { consumer } from '@tock/coretypes';
import { defaultShareImage } from 'constants/social';
import { imageUrl } from '@tock/images';

export function getFirstExperienceImage(experience?: consumer.Offering) {
  if (experience?.imageUrl && experience.imageUrl.length > 0) {
    return imageUrl(experience.imageUrl[0]);
  }
  return defaultShareImage;
}

export function getExperienceImages(experience?: consumer.Offering) {
  return experience?.imageUrl
    ? experience.imageUrl.map((imgUrl) => imageUrl(imgUrl))
    : [defaultShareImage];
}
